function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#social-facebook_svg__clip0_1855_724)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35 .47H5c-2.757 0-5 2.242-5 5v30c0 2.757 2.243 5 5 5h30c2.758 0 5-2.243 5-5v-30c0-2.758-2.242-5-5-5z",
  fill: "#1976D2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.75 20.47H23.5v-5c0-1.38 1.12-1.25 2.5-1.25h2.5V7.97h-5a7.5 7.5 0 00-7.5 7.5v5h-5v6.25h5v13.75h7.5V26.72h3.75l2.5-6.25z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "social-facebook_svg__clip0_1855_724"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .47)",
  d: "M0 0h40v40H0z"
})));

function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSocialFacebook;